import { render } from "./ContentComplements.vue?vue&type=template&id=840045fa&scoped=true&ts=true"
import script from "./ContentComplements.vue?vue&type=script&lang=ts"
export * from "./ContentComplements.vue?vue&type=script&lang=ts"

import "./ContentComplements.vue?vue&type=style&index=0&id=840045fa&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-840045fa"]])

export default __exports__